import { useMemo } from 'react';
import { useWidgetConfig } from '../providers';
export const useFeaturedTokens = (selectedChainId) => {
    const { featuredTokens, tokens } = useWidgetConfig();
    return useMemo(() => {
        var _a;
        return [...((_a = tokens === null || tokens === void 0 ? void 0 : tokens.featured) !== null && _a !== void 0 ? _a : []), ...(featuredTokens !== null && featuredTokens !== void 0 ? featuredTokens : [])].filter((token) => token.chainId === selectedChainId);
    }, [featuredTokens, selectedChainId, tokens === null || tokens === void 0 ? void 0 : tokens.featured]);
};
